<template>
  <base-page-layout title="Site de cadastramento" class="hotsite">
    <v-container fluid class="px-1">
      <v-skeleton-loader type="article, list-item-three-line@4" :loading="$apollo.loading">
        <hotsite-slots-table v-if="allowHotsiteManagement" />
        <dynamic-attributes-table v-if="allowDynamicAttributesManagement" class="mt-8" />
        <v-card class="mt-8">
          <v-card-title class="section-title py-6 mb-0"> Campos do cadastro </v-card-title>
          <v-card-text>
            <v-card class="media-card" flat>
              <div class="card-item">
                <mf-toggle v-model="passwordVisble" label="Habilitar senha no cadastro" class="mr-1 mb-2" hide-details />
                <p class="mb-0">
                  Caso essa opção esteja marcada, o usuário precisará informar uma senha no cadastro. Ele utilizará essa senha para acessos futuros. Caso esteja
                  desmarcada, o usuário irá finalizar um cadastro sem senha. Quando necessitar acessar os seus dados, precisará passar pelo fluxo de verificação
                  de identidade.
                </p>
              </div>
            </v-card>

            <v-card class="media-card" flat>
              <div class="card-item">
                <mf-toggle v-model="emailRequired" label="E-mail obrigatório" class="mr-1 mb-2" hide-details />
                <p class="mb-0">Caso essa opção esteja marcada, novos cadastros precisarão informar um e-mail válido e único para finalizar o cadastro.</p>
              </div>
            </v-card>

            <v-card class="media-card" flat>
              <div class="card-item">
                <mf-toggle v-model="enableDeleteDataRequests" label="Habilitar exclusão de dados" class="mr-1 mb-2" hide-details />
                <p class="mb-0">Aqui você pode habilitar as opções de sair do clube e solicitar deleção de dados.</p>

                <v-expand-transition>
                  <div v-if="enableDeleteDataRequests" class="mt-4">
                    <mf-toggle v-model="enableDeletePartialDataRequests" label="Habilitar exclusão parcial de dados" class="mr-1 mb-2" hide-details />
                    <p class="mb-0">Aqui você pode habilitar as opções de solicitar deleção parcial de dados.</p>
                  </div>
                </v-expand-transition>

                <div class="d-flex icon-container mt-4">
                  <mf-icon fill medium color="cinza-d10"> warning </mf-icon>
                  <p>
                    A opção de exclusão de dados não pode ser desabilita nos aplicativos Mercafacil, por
                    <a class="link" href="https://developer.apple.com/support/offering-account-deletion-in-your-app" target="_blank"
                      >normativas e politicas das lojas.</a
                    >
                  </p>
                </div>
              </div>
            </v-card>

            <v-card v-if="$getAllowedModules().hotsite_international" class="media-card" flat>
              <v-card-title>
                <span> Cadastro de pessoas estrangeiras </span>
              </v-card-title>
              <v-card-text>
                Permitir o cadastro de pessoas com documentação, endereço e número de telefone de fora do Brasil.

                <div class="d-flex icon-container mt-3">
                  <v-select v-model="allowedCountries" :items="items" item-text="label" item-value="value" outlined multiple>
                    <template #item="{ item, attrs }">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <v-icon v-bind="attrs.icon">{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                    </template>
                  </v-select>
                </div>
              </v-card-text>
            </v-card>

            <v-card-title class="section-title mt-2 mb-5 pa-0">Tela de sucesso</v-card-title>

            <v-card class="media-card" flat>
              <div class="card-item">
                <mf-toggle v-model="enableWhatsappLink" label="Link do Whatsapp na tela de sucesso" class="mr-1 mb-2" hide-details />
                <v-expand-transition>
                  <div v-if="enableWhatsappLink">
                    <p class="mb-0">
                      Configure o número do Whatsapp e mensagem de início de conversa que será exibido na tela de sucesso de cadastro do consumidor.
                    </p>

                    <div class="inputs-container">
                      <div class="mt-6">
                        <label for="whatsappNumber">Número de Whatsapp</label>
                        <v-text-field
                          id="whatsappNumber"
                          v-model="finishScreenWhatsapp"
                          v-mask="['+55 (##) #####-####', '+55 (##) ####-####']"
                          outlined
                          placeholder="+55 (99) 99999-9999"
                          :error-messages="errorMessages.finishScreenWhatsapp"
                          dense
                          class="mt-1"
                        />
                      </div>
                      <div class="mt-3">
                        <div class="d-flex align-center pb-1">
                          <label for="whatsappNumber">Mensagem de início de conversa (opcional)</label>
                          <mf-tooltip variant="secondary" top max-width="300">
                            <template v-slot:activator>
                              <mf-icon color="cinza-0" size="20" class="ml-1" icon="info" />
                            </template>
                            Mensagem configurada para ser exibida no celular do consumidor ao entrar no link.
                          </mf-tooltip>
                        </div>
                        <mf-textarea-emoji
                          v-model="finishScreenWhatsappMessage"
                          hide-details
                          outlined
                          no-resize
                          hide-counter
                          auto-grow
                          rows="5"
                          placeholder="Texto da mensagem"
                        />
                      </div>
                    </div>
                  </div>
                </v-expand-transition>
              </div>
            </v-card>

            <v-card class="media-card" flat>
              <div class="card-item">
                <mf-toggle v-model="enableApps" label="Link do Aplicativo" class="mr-1 mb-2" hide-details />
                <p class="mb-0">
                  Habilitando esse campo, será exibido na tela inicial e na tela de sucesso do Site de cadastramento um link e QR code para o aplicativo, tanto
                  da Play Store (Android) quanto da App Store (iOS).
                </p>
              </div>
            </v-card>
          </v-card-text>
        </v-card>

        <v-card class="mt-8">
          <v-card-title class="section-title pt-6 pb-2 ma-0">Links do rodapé</v-card-title>
          <v-card-text>
            Links são ótimas formas de levar seu consumidor para algum outro canal seu.
            <v-card class="media-card mt-4" flat>
              <v-card-title class="pb-2">
                <span>Novo link</span>
              </v-card-title>
              <v-card-text>
                O link aparece no rodapé do seu site de cadastramento, perto do link dos termos de aceite do clube. Nos campos abaixo é necessário configurar o
                nome que o usuario vê, e o link para onde ele deve ir caso clique no mesmo. Para remover o link extra, esvazie ambos os campos.

                <div v-for="(link, index) in hotsite_links" :key="index" class="d-flex link-inputs mt-4">
                  <v-text-field
                    v-model.trim="link.name"
                    :error="!!linkNameError(index)"
                    :error-messages="linkNameError(index)"
                    label="Nome de exibição"
                    outlined
                  />
                  <v-text-field v-model.trim="link.url" :error="!!linkUrlError(index)" :error-messages="linkUrlError(index)" label="Link de destino" outlined />

                  <mf-tooltip top max-width="200px">
                    <template #activator>
                      <mf-button class="mt-3" color="vermelho-d20" type="icon" icon="delete" @click="removeLink(index)" />
                    </template>
                    <span>Deletar link</span>
                  </mf-tooltip>
                </div>

                <mf-button class="mt-2" text color="marca-0-l40" label="Adicionar novo link" icon="add" @click="addLink" />
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>

        <v-card class="mt-8">
          <v-card-title class="section-title py-6"> Recuperação de senhas </v-card-title>
          <v-card-text>
            <v-card class="media-card" flat>
              <v-card-title>
                <span> Canais </span>
              </v-card-title>
              <v-card-text>
                Escolha aqui quais canais teu consumidor pode escolher para recuperação de senha via hotsite de cadastramento. Lembrando que o canal SMS deve
                possuir créditos disponíveis para que teu consumidor receba de fato o SMS. E o disparo de e-mail é gratuito, porém clientes sem e-mail
                cadastrado não poderão receber recuperação de senha por esse canal.
                <mf-toggle v-model="recoveryPasswordWithSms" class="ml-1" label="SMS" hide-details />
                <mf-toggle v-model="recoveryPasswordWithEmail" class="ml-1" label="E-mail" hide-details disabled />
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <span>
                  <b> {{ passwordRecoveryBalance | localeString }} </b> créditos SMS disponíveis
                </span>
              </v-card-title>
              <v-card-text> Para adquirir créditos para este fim, entre em contato com o seu consultor Mercafacil. </v-card-text>
            </v-card>

            <v-card class="media-card" flat>
              <v-card-title>
                <span> Nome do clube </span>
              </v-card-title>
              <v-card-text>
                Este nome será utilizado no conteúdo do e-mail enviado para recuperação de senha.
                <v-flex xs6>
                  <v-text-field v-model="loyaltyClubName" outlined label="Nome do clube" class="tag-input mt-3"> </v-text-field>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>

        <v-card class="mt-8">
          <v-card-title class="section-title py-6 mb-0"> Dados de contato da loja </v-card-title>
          <v-card-text>
            <v-card class="media-card" flat>
              <v-card-title>
                <span> Canais de atendimento </span>
              </v-card-title>
              <v-card-text>
                Os clientes que não possuírem e-mail ou celular cadastrados não conseguirão recuperar ou cadastrar uma nova senha. Para resolver esse caso,
                iremos disponibilizar o contato do mercado no hotsite. Para editar os dados de contato desses clientes, basta acessar a tela de gerenciamento de
                clientes.

                <!-- Phone -->
                <v-row class="mt-4 ml-4">
                  <v-flex xs3>
                    <v-text-field
                      v-model="phoneToInsert"
                      v-mask="['+55 (##) #####-####', '+55 (##) ####-####']"
                      outlined
                      label="Telefone"
                      class="tag-input"
                      :error-messages="errorMessages.phones"
                      @keyup.enter="insertPhone"
                    >
                      <template #append>
                        <mf-icon icon="add" class="cursor-pointer" @click="insertPhone" />
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-chip-group show-arrows active-class="primary--text" class="mt-2 ml-2">
                      <v-chip v-for="(tag, index) in phones" :key="index" small close @click:close="deletePhone(tag)">
                        <span>{{ tag }}</span>
                      </v-chip>
                    </v-chip-group>
                  </v-flex>
                </v-row>

                <!-- NUN Phone -->
                <v-row class="mt-4 ml-4">
                  <v-flex xs3>
                    <v-text-field
                      :key="nunPhoneInputKey"
                      v-model="nunPhoneToInsert"
                      v-mask="nunMasks"
                      outlined
                      label="Número Único Nacional"
                      class="tag-input"
                      :error-messages="errorMessages.nunPhone"
                      @keyup.enter="insertNunPhone"
                    >
                      <template #append>
                        <mf-icon icon="add" class="cursor-pointer" @click="insertNunPhone" />
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-chip-group show-arrows active-class="primary--text" class="mt-2 ml-2">
                      <v-chip v-for="(tag, index) in nunPhones" :key="index" small close @click:close="deletePhone(tag)">
                        <span>{{ tag }}</span>
                      </v-chip>
                    </v-chip-group>
                  </v-flex>
                </v-row>

                <!-- Email -->
                <v-row class="ml-4">
                  <v-flex xs3>
                    <v-text-field
                      v-model="emailToInsert"
                      outlined
                      label="E-mail"
                      class="tag-input"
                      :error-messages="errorMessages.emails"
                      @keyup.enter="insertEmail"
                    >
                      <template #append>
                        <mf-icon icon="add" class="cursor-pointer" @click="insertEmail" />
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-chip-group show-arrows active-class="primary--text" class="mt-2 ml-2">
                      <v-chip v-for="(email, index) in contacts.emails" :key="index" small close @click:close="deleteEmail(index)">
                        <span>{{ email }}</span>
                      </v-chip>
                    </v-chip-group>
                  </v-flex>
                </v-row>

                <!-- Whatsapp -->
                <v-row class="ml-4">
                  <v-flex xs3>
                    <v-text-field
                      v-model="whatsToInsert"
                      v-mask="['+55 (##) #####-####', '+55 (##) ####-####']"
                      outlined
                      label="Whatsapp"
                      class="tag-input"
                      :error-messages="errorMessages.whatsapp"
                      @keyup.enter="insertWhats"
                    >
                      <template #append>
                        <mf-icon icon="add" class="cursor-pointer" @click="insertWhats" />
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-chip-group show-arrows active-class="primary--text" class="mt-2 ml-2">
                      <v-chip v-for="(whats, index) in contacts.whatsapp" :key="index" small close @click:close="deleteWhats(index)">
                        <span>{{ whats }}</span>
                      </v-chip>
                    </v-chip-group>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>

        <v-card class="mt-8">
          <v-card-title class="section-title py-6 mb-0"> Mensuração de anúncios </v-card-title>
          <v-row class="equal-height-row">
            <v-col cols="12" md="6" class="d-flex">
              <ads-pixel-facebook-configuration v-model="facebookPixel" class="flex-grow-1" />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <ads-google-analytics-configuration v-model="googleAnalytics" class="flex-grow-1" />
            </v-col>
          </v-row>
        </v-card>
      </v-skeleton-loader>
      <mf-action-buttons
        class="mt-2"
        :primary-button="{
          text: 'Salvar alterações',
          action: save,
          isVisible: true,
          isLoading: $apollo.loading || loading,
        }"
        :extra-button="{
          text: 'Descartar alterações ',
          action: restore,
          isVisible: true,
          isDisabled: $apollo.loading || loading,
        }"
      />
    </v-container>
  </base-page-layout>
</template>

<script>
import {
  HOTSITE_SIGNUP_CONFIGURATION_INPUT,
  HOTSITE_CONFIGURATION,
  UPDATE_HOTSITE_SIGNUP_CONFIGURATION,
  PASSWORD_RECOVERY_BALANCE,
} from '@/modules/configuracoes/site-de-cadastramento/graphql'
import { deepDelete } from '@/helpers/deepDelete'
import { validEmail, isUrl, validPhoneNumber } from '@/helpers/validators.js'
import Swal from 'sweetalert2'
import { requiredIf, required } from 'vuelidate/lib/validators'

const NUN_PREFIX_PHONES = ['4004', '4003', '0800']

export default {
  name: 'Hotsite',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    HotsiteSlotsTable: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/HotsiteSlotsTable.vue'),
    AdsPixelFacebookConfiguration: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AdsPixelFacebookConfiguration.vue'),
    AdsGoogleAnalyticsConfiguration: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AdsGoogleAnalyticsConfiguration.vue'),
    DynamicAttributesTable: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/DynamicAttributesTable.vue'),
  },
  data: () => ({
    loader: false,
    loading: false,
    emailRequired: false,
    passwordVisble: false,
    contacts: {
      emails: [],
      phones: [],
      whatsapp: [],
    },
    recoveryPasswordWithEmail: true,
    recoveryPasswordWithSms: false,
    facebookPixel: '',
    googleAnalytics: '',
    nunPhoneInputKey: 0,
    select: [],
    nunPhoneToInsert: '',
    phoneToInsert: '',
    emailToInsert: '',
    whatsToInsert: '',
    loyaltyClubName: '',
    passwordRecoveryBalance: '',
    enableDeleteDataRequests: false,
    enableDeletePartialDataRequests: false,
    enableWhatsappLink: false,
    enableApps: false,
    finishScreenWhatsapp: null,
    finishScreenWhatsappMessage: '',
    hotsite_links: [
      {
        name: '',
        url: '',
      },
    ],
    items: [
      {
        label: 'Brasil',
        value: 'BRASIL',
        icon: 'brasil',
      },
      {
        label: 'Argentina',
        value: 'ARGENTINA',
        icon: 'argentina',
      },
      {
        label: 'Uruguai',
        value: 'URUGUAY',
        icon: 'uruguai',
      },
    ],
    allowedCountries: ['BRASIL'],
  }),
  computed: {
    allowDynamicAttributesManagement() {
      return this.$getAllowedModules().dynamic_attributes
    },
    allowHotsiteManagement() {
      if (this.$getIsAdmin()) return true
      return this.$getAllowedModules().hotsite_management
    },
    errorMessages() {
      const errors = []
      if (
        (this.nunPhoneToInsert.length < 9 ||
          (this.nunPhoneToInsert.length > 9 && this.nunPhoneToInsert.length < 13) ||
          !NUN_PREFIX_PHONES.includes(this.nunPhoneToInsert.slice(0, 4))) &&
        this.nunPhoneToInsert !== ''
      )
        errors['nunPhone'] = 'Número Único Nacional inválido'
      if (this.phoneToInsert.length < 18 && this.phoneToInsert !== '') errors['phones'] = 'Telefone inválido'
      if (this.whatsToInsert.length < 18 && this.whatsToInsert !== '') errors['whatsapp'] = 'Telefone inválido'
      if (typeof this.finishScreenWhatsapp === 'string' && this.finishScreenWhatsapp.length < 18) errors['finishScreenWhatsapp'] = 'Telefone inválido'
      if (!validEmail(this.emailToInsert) && this.emailToInsert !== '') errors['emails'] = 'Email inválido'
      return errors
    },
    nunMasks() {
      return this.nunPhoneToInsert.length > 9 ? ['#### ### ####'] : ['#### ####']
    },
    nunPhones() {
      return this.contacts.phones.filter((phone) => NUN_PREFIX_PHONES.includes(phone.slice(0, 4)))
    },
    phones() {
      return this.contacts.phones.filter((phone) => !NUN_PREFIX_PHONES.includes(phone.slice(0, 4)))
    },
  },

  apollo: {
    signupConfiguration: {
      query: HOTSITE_SIGNUP_CONFIGURATION_INPUT,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      update({ account }) {
        this.emailRequired = account?.channels?.hotsite?.configuration?.email_required ?? false
        this.passwordVisble = account?.channels?.hotsite?.configuration?.password_visible ?? false
        this.loyaltyClubName = account?.loyalty_club_name || ''
        this.googleAnalytics = account?.channels?.hotsite?.configuration?.google_analytics_id
        this.facebookPixel = account?.channels?.hotsite?.configuration?.facebook_pixel_id
        this.allowedCountries = account?.channels?.hotsite?.configuration?.allowed_countries
        return account
      },
    },
    configuration: {
      query: HOTSITE_CONFIGURATION,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      update({ configuration }) {
        this.contacts.emails = configuration?.contacts?.emails ?? []
        this.contacts.phones = configuration?.contacts?.phones ?? []
        this.contacts.whatsapp = configuration?.contacts?.whatsapp ?? []
        this.recoveryPasswordWithSms = configuration?.password_recovery_channels?.sms ?? false
        this.enableDeleteDataRequests = configuration?.enable_delete_data_requests ?? false
        this.enableDeletePartialDataRequests = configuration?.enable_delete_partial_data_requests ?? false
        this.hotsite_links = configuration?.hotsite_links && configuration?.hotsite_links.length ? configuration.hotsite_links : [{ name: '', url: '' }]
        this.enableWhatsappLink = configuration.enable_whatsapp_link ?? false
        this.enableApps = configuration.enable_apps ?? false

        if (configuration.whatsapp_link) {
          const params = new URLSearchParams(new URL(configuration.whatsapp_link).search)
          this.finishScreenWhatsapp = params.get('phone').replace(/\D/g, '') || null
          this.finishScreenWhatsappMessage = params.get('text')
        }

        return configuration
      },
    },

    passwordRecoveryBalance: {
      query: PASSWORD_RECOVERY_BALANCE,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      update({ passwordRecoveryBalance }) {
        return parseInt(passwordRecoveryBalance) || 0
      },
    },
  },

  watch: {
    enableDeleteDataRequests(newValue, oldValue) {
      if (newValue === oldValue) return

      if (!newValue) {
        this.enableDeletePartialDataRequests = false
      } else if (newValue && !this.enableDeletePartialDataRequests) {
        this.enableDeletePartialDataRequests = true
      }
    },
  },
  methods: {
    restore() {
      this.$apollo.queries.configuration.refresh()
      this.$apollo.queries.signupConfiguration.refresh()
      window.scrollTo(0, 0)
    },
    async save() {
      this.finishScreenWhatsapp = this.finishScreenWhatsapp === null ? '' : this.finishScreenWhatsapp

      this.$v.$reset()
      this.$v.$touch()

      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })

        return
      }

      const whatsappLink = this.finishScreenWhatsapp
        ? `https://api.whatsapp.com/send?phone=${this.finishScreenWhatsapp.replace(/[ ()-]/g, '')}&text=${this.finishScreenWhatsappMessage}`
        : ''

      const variables = {
        passwordVisible: this.passwordVisble,
        emailRequired: this.emailRequired,
        pixelId: this.facebookPixel,
        allowedCountries: this.allowedCountries || [],
        googleAnalyticsId: this.googleAnalytics,
        phones: this.contacts.phones,
        emails: this.contacts.emails,
        whatsapp: this.contacts.whatsapp,
        recoverPasswordWithEmail: this.recoveryPasswordWithEmail,
        recoverPasswordWithSms: this.recoveryPasswordWithSms,
        loyaltyClubName: this.loyaltyClubName,
        enableDeleteDataRequests: this.enableDeleteDataRequests,
        enableDeletePartialDataRequests: this.enableDeletePartialDataRequests,
        hotsite_links: this.hotsite_links
          .map((link) => {
            return {
              url: link.url,
              name: link.name,
            }
          })
          .filter((link) => link.url && link.name),
        enable_whatsapp_link: this.enableWhatsappLink,
        enable_apps: this.enableApps,
        whatsapp_link: whatsappLink,
      }
      deepDelete(variables, ['__typename', 'index'])

      try {
        this.loading = true
        await this.$apollo.mutate({
          mutation: UPDATE_HOTSITE_SIGNUP_CONFIGURATION,
          variables,
        })
      } catch (e) {
        this.$snackbar({ message: `Falha ao salvar alterações: ${e.message}` })
        return
      } finally {
        this.loading = false
      }
      Swal.fire({
        text: 'Dados atualizados!',
        icon: 'success',
        showConfirmButton: false,
        timer: 1000,
        customClass: {
          content: 'content-class',
        },
      })
      this.finishScreenWhatsapp = this.finishScreenWhatsapp || null
      this.$apollo.queries.configuration.refresh()
      this.$apollo.queries.signupConfiguration.refresh()
    },

    insertPhone() {
      if (!this.errorMessages.phones && this.phoneToInsert !== '') {
        this.contacts.phones.push(this.phoneToInsert)
        this.phoneToInsert = ''
      }
    },

    insertNunPhone() {
      if (!this.errorMessages.nunPhone && this.nunPhoneToInsert !== '') {
        this.contacts.phones.push(this.nunPhoneToInsert)
        this.nunPhoneToInsert = ''
        this.nunPhoneInputKey += 1
      }
    },

    deleteEmail(index) {
      return this.contacts.emails.splice(index, 1)
    },

    insertEmail() {
      if (!this.errorMessages.emails && this.emailToInsert !== '') {
        this.contacts.emails.push(this.emailToInsert)
        this.emailToInsert = ''
      }
    },

    deletePhone(phone) {
      return this.contacts.phones.splice(this.contacts.phones.indexOf(phone), 1)
    },

    insertWhats() {
      if (!this.errorMessages.whatsapp && this.whatsToInsert !== '') {
        this.contacts.whatsapp.push(this.whatsToInsert)
        this.whatsToInsert = ''
      }
    },

    deleteWhats(index) {
      return this.contacts.whatsapp.splice(index, 1)
    },

    addLink() {
      const newLink = {
        name: '',
        url: '',
      }

      this.hotsite_links.push(newLink)
    },

    async removeLink(index) {
      const confirmed = await this.$confirm({
        title: 'Remover link',
        message: 'Tem certeza? Remover esse link implica em removê-lo também do rodapé do site de cadastramento. Essa ação não poderá ser desfeita.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.hotsite_links.splice(index, 1)
      if (this.hotsite_links.length === 0) {
        this.hotsite_links.push({
          name: '',
          url: '',
        })
      }
    },

    linkNameError(index) {
      if (this.$v.hotsite_links.$error && this.$v.hotsite_links.$each[index].name.$invalid) return 'Lembre de dar um nome amigável para o seu link'
      return ''
    },

    linkUrlError(index) {
      if (this.$v.hotsite_links.$error && this.$v.hotsite_links.$each[index].url.$invalid) return 'Insira um link https válido'
      return ''
    },
  },

  validations() {
    return {
      ...(this.enableWhatsappLink
        ? {
            finishScreenWhatsapp: {
              required,
              validPhoneNumber,
            },
          }
        : {}),
      hotsite_links: {
        $each: {
          name: {
            required: requiredIf(function (link) {
              return link.url
            }),
          },
          url: {
            required: requiredIf(function (link) {
              return link.name
            }),
            isUrl,
          },
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.hotsite {
  $background-card-color: $cinza-l90;

  .v-text-field__slot input {
    color: $cinza-0;
  }

  .media-card {
    background-color: $background-card-color;
    margin-bottom: 25px;
  }
  .table-card {
    background-color: $background-card-color;
  }
  .icon-container {
    align-items: center !important;
    gap: 10px;
    & p {
      margin: 0;
      max-width: 540px;
      color: $cinza-0;
      font-size: 14px;
      line-height: 120%;
    }
  }

  .equal-height-row {
    .v-col {
      display: flex;
      align-items: stretch;
    }
  }
}

.edit_square_icon:hover {
  .mf-icon {
    color: $marca-0-l20 !important;
  }
}

.delete_icon:hover {
  .mf-icon {
    color: $vermelho-d20 !important;
  }
}

.link-inputs {
  max-width: 680px;
  border-bottom: 1px solid $cinza-l70;
  gap: 12px;

  & .v-input {
    max-width: 300px;
  }
}
.link-inputs + .link-inputs {
  padding-top: 12px;
}

.card-item {
  padding: 20px 24px 36px;

  ::v-deep label {
    color: $cinza-d10 !important;
    font-weight: 400;
    font-size: 18px !important ;
  }

  p {
    color: $cinza-0;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.2;
  }
}

.inputs-container {
  max-width: 574px;

  label {
    font-weight: 700;
    font-size: 14px !important;
    line-height: 20px;
    color: $cinza-d20 !important;
  }
}
</style>
